import Footer, { FooterProps } from 'components/gruenland/organisms/footer/Footer';
import { MarketProvider } from 'context/market';
import { TasticProps } from 'frontastic/tastics/types';

const FooterMenuTastic = ({ data }: TasticProps<FooterProps>) => {
  return (
    <MarketProvider>
      <Footer {...data} />
    </MarketProvider>
  );
};

export default FooterMenuTastic;
